import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useMediaQuery } from 'react-responsive'
import { Logger } from '../../../../../libs/utils/logger';
import { callAPI, Method, updateComponentParams } from '../../../../Utils/CommonBaseClass';
import { RegisterComponent } from '../../../../../libs/saga/dataSaga';
import { JointTenancyCoOwnerSignUpLeftBar } from './JointTenancyCoOwnerSignUpLeftBar';
import { JointTenancyCoOwnerReviewAndSubmitSignup } from './JointTenancyCoOwnerReviewAndSubmitSignup';
import { useDispatch } from 'react-redux';
import { getKey } from '../../../../../libs/utils/storageManager';
import { processAPIResponse } from '../../../../../libs/utils/utils';

/**
 * Author : Shivaraj PP
 * Component: Signup Joint 
 * Usage: User signup page
 */

Logger.debug("JointTenancyCoOwnerSignUp.tsx", "SignUp initializing")

export const JointTenancyCoOwnerSignUp: React.FC<any> = React.memo(
    (props) => {
        let context: any;
        ({ context, props } = RegisterComponent(props));
        const { isLoading, step } = props;
        const dispatch = useDispatch();
        const isSmallScreen = useMediaQuery({ query: '(max-width: 600px)' })

        /**
         * UseEffect hook resets the parameters
         */
        useEffect(() => {
            updateComponentParams(dispatch, props.id, { isLoading: false, step: 1 });
            return () => {
                dispatch({ type: 'DATA_COMPONENT_RESET', payload: { id: props.id } });
              }
          },[dispatch,props.id,])
          

          /**
         * Handles the submission of reviewed joint tenancy co-owner data.
         *
         * - Currently logs the submitted request object to the console.
         * - Intended for processing or sending co-owner review data in the future.
         *
         * @param req - The reviewed joint tenancy co-owner data.
         */
        const handleReviewJointTenancyCoOwnerSubmit = (req:any) => {
            console.log(req,'req main')
        }
       
        
        /**
         * Handles submission of beneficial owner information for a joint tenancy.
         *
         * - Constructs a request payload using the provided request object.
         * - Sends the payload to the API to update KYC (Know Your Customer) information.
         * - Dispatches an action to update application state upon successful API call.
         *
         * @param data - The form data being submitted.
         * @param req - The request-related object containing owner information.
         * @param index - The index indicating the current owner in context.
         */
        const handleBeneficialOwnerSubmit = async (data: any, req: any, index: number) => {
            // Clone the request object into an array
            let benOwnerReq = [{ ...req }];

            // Construct the API request payload
            const ApiReq: any = {
                type: "JOINT_TENANCY",
                isKycUpdate: true,
                owners: benOwnerReq,
            };

            // Create the API URL using the customer ID
            const url: any = "customer/id/" + getKey('customerId');

            // Call the API and process the response
            let status = await callAPI(url, Method.POST, ApiReq);
            status = processAPIResponse(status);

            // If API call is successful, dispatch a state update to fetch the data
            if (status.status) {
                dispatch({
                    type: 'DATA_API_PARAM_CHANGED',
                    payload: {
                        id: `joint-tenancy-user-signup`,
                        source: { url: `/`, method: "GET" }
                    }
                });
            }
        };


        return (
            <Grid item xs={12} container direction="row" className='fx-form-grid fx-join-tenancy-co-owner'>
                {!isSmallScreen && <Grid item xs={3} sm={4} md={3} container direction="row" alignContent="flex-start" className="fx-login-promo-parent">
                    <JointTenancyCoOwnerSignUpLeftBar activeMenu={step} />
                </Grid>}
                {isSmallScreen && <Grid item xs={12} container direction="row" alignContent="flex-start" sm={12} className="fx-login-promo-parent">
                    <JointTenancyCoOwnerSignUpLeftBar activeMenu={step} />
                </Grid>}
                {<Grid className={`left-sidebar-signup ${step === 1 ? 'active' : ''}`} item xs={12} sm={isSmallScreen ? undefined : 8} md={isSmallScreen ? undefined : 9} container direction="row" alignContent="flex-start">
                    <JointTenancyCoOwnerReviewAndSubmitSignup reviewDetails={context?.data?.body?.owners} onSubmit={handleBeneficialOwnerSubmit} loading={isLoading} />
                </Grid >}
            </Grid >
        );
    });